import { InAppNotificationDto } from "@/types";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import {
    getNotifications,
    getUnreadNotifications,
    markNotificationAsRead,
    NOTIFICATIONS_PAGE_SIZE
} from "../notificationApi";
import { NormalizedSearchResultDto } from "../claimsInvoicingApi";

const unreadNotificationsQueryKey = ["notifications", "unread"] as const;
const allNotificationsQueryKey = ["notifications", "all"] as const;

const getUnreadNotificationsQueryOptions = () =>
    queryOptions<InAppNotificationDto[]>({
        queryKey: unreadNotificationsQueryKey,
        queryFn: () => getUnreadNotifications()
    });

const getNotificationsInfiniteQueryOptions = () =>
    infiniteQueryOptions<NormalizedSearchResultDto<InAppNotificationDto>>({
        queryKey: allNotificationsQueryKey,
        initialPageParam: 0,
        queryFn: ({ pageParam }) =>
            getNotifications({
                page: pageParam as number,
                limit: NOTIFICATIONS_PAGE_SIZE
            }),
        getNextPageParam: lastPage => {
            if (!lastPage.items || lastPage.items.length < NOTIFICATIONS_PAGE_SIZE) {
                return undefined;
            }

            const nextPage = lastPage.pageIndex + 1;
            const loadedCount = nextPage * NOTIFICATIONS_PAGE_SIZE;

            if (loadedCount >= lastPage.totalResults) {
                return undefined;
            }

            return nextPage;
        }
    });

const markNotificationAsReadMutationOptions = {
    mutationFn: (notificationId: string) => markNotificationAsRead(notificationId)
};

export {
    getUnreadNotificationsQueryOptions,
    getNotificationsInfiniteQueryOptions,
    markNotificationAsReadMutationOptions,
    unreadNotificationsQueryKey,
    allNotificationsQueryKey
};
